import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { TeamSection } from '@/components/sections/TeamSection';
import { alleMitarbeitenden } from '@/lib/content/team';
import { teamBild } from '@/lib/images';

const seo = {
  title: 'Marlene Gujan Architektur AG | Team',
  description: 'Lernen Sie das engagierte und erfahrene Team der Marlene Gujan Architektur AG in Igis kennen.',
  keywords: 'Team, Marlene Gujan, Architektur, Igis, Mitarbeiter, Architekturbüro',
  canonicalUrl: 'https://www.gujan-architektur.ch/buero/team',
};

export default function Team({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <TeamSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  const mitarbeitende = await alleMitarbeitenden();

  // Das Foto kommt aus dem Bild-Manifest, nicht aus der Datenbank. Es hier
  // aufzuloesen statt in der Komponente hat einen Grund: wer ueber die
  // Verwaltung eine Person anlegt, hat noch kein Foto im Repo - dann steht
  // hier das Standardbild statt eines toten Pfads.
  const data = mitarbeitende.map((person) => ({
    ...person,
    bild: teamBild(person.mitarbeiter_id).url,
  }));

  return { props: { data }, revalidate: 300 };
}
